module.exports = __webpack_public_path__ + "img/cap_12.4fd10e1a.jpg";